<template>
  <div>
    <router-view style="height: 100vh"></router-view>
  </div>
</template>

<script>
import Scroll from '_c/Scroll';
export default {
  name: 'gameCircle',
  components: {
    Scroll
  }
}
</script>

<style lang="scss" module></style>